"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get addToQueue () {
        return addToQueue;
    },
    get filterExternalDependencies () {
        return filterExternalDependencies;
    },
    get resolveExternalDependencies () {
        return resolveExternalDependencies;
    }
});
const _workspacetools = require("workspace-tools");
const _nameAtVersion = require("./nameAtVersion.js");
function filterExternalDependencies(dependencies, workspaces) {
    const workspacePackageNames = (0, _workspacetools.listOfWorkspacePackageNames)(workspaces);
    const externalDependencies = {};
    Object.entries(dependencies).forEach(([name, versionRange])=>{
        if (workspacePackageNames.indexOf(name) < 0) {
            externalDependencies[name] = versionRange;
        }
    });
    return externalDependencies;
}
function isDone(done, key) {
    return done.indexOf(key) >= 0;
}
function isInQueue(queue, key) {
    return Boolean(queue.find(([name, versionRange])=>(0, _nameAtVersion.nameAtVersion)(name, versionRange) === key));
}
function addToQueue(dependencies, done, queue) {
    if (dependencies) {
        Object.entries(dependencies).forEach(([name, versionRange])=>{
            const versionRangeSignature = (0, _nameAtVersion.nameAtVersion)(name, versionRange);
            if (!isDone(done, versionRangeSignature) && !isInQueue(queue, versionRangeSignature)) {
                queue.push([
                    name,
                    versionRange
                ]);
            }
        });
    }
}
function resolveExternalDependencies(allDependencies, workspaces, lockInfo) {
    const externalDependencies = filterExternalDependencies(allDependencies, workspaces);
    const done = [];
    const doneRange = [];
    const queue = Object.entries(externalDependencies);
    while(queue.length > 0){
        const next = queue.shift();
        if (!next) {
            continue;
        }
        const [name, versionRange] = next;
        doneRange.push((0, _nameAtVersion.nameAtVersion)(name, versionRange));
        const lockFileResult = (0, _workspacetools.queryLockFile)(name, versionRange, lockInfo);
        if (lockFileResult) {
            const { version, dependencies } = lockFileResult;
            addToQueue(dependencies, doneRange, queue);
            done.push((0, _nameAtVersion.nameAtVersion)(name, version));
        } else {
            done.push((0, _nameAtVersion.nameAtVersion)(name, versionRange));
        }
    }
    return done;
}
